if (!customElements.get('grouper-tag-element')) {
  class GrouperTag extends HTMLElement {
    constructor() {
      super();

      this.items = this.querySelectorAll('[data-group-item]');
      this.colorLabel = this.querySelector('[data-group-label]');
      this.colorToggleButton = this.querySelector('[data-color-toggle]');

      // Bind popup toggle events
      if (this.colorToggleButton){
        this.colorToggleButton.addEventListener("click", function() {
          const popup = document.querySelector('[data-colors-wrapper]');

          this.classList.toggle('options__grouper-tag-button--is-open')
          popup.classList.toggle('visibility-hidden');
        });
      }

      this.items.forEach((item) => {
        item.addEventListener('click', function() {
          item.classList.add('loading');
        });
      });
    }
  }


  customElements.define('grouper-tag-element', GrouperTag);
}